import React from "react";
import { makeStyles } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { ThemeType } from "@theme";
import { SpinnerOverlay } from "@components";
import { withErrorBoundary } from "@components/error-boundary";

type Props = {
  id: string;
  loading?: boolean;
  main: React.ReactNode;
  topbar: React.ReactNode;
  rightBar: React.ReactNode;
};

const AccommodationProfileLayout: React.FC<Props> = ({
  id,
  main,
  topbar,
  rightBar,
  loading
}) => {
  const classes = useStyles({});
  return (
    <Grid
      container
      spacing={2}
      className={classes.root}
      data-test="CustomerProfileLayout"
      data-test-id={id}
    >
      <SpinnerOverlay show={loading} />

      <Grid item xs={12}>
        {withErrorBoundary(topbar)}
      </Grid>

      <Grid item xs={12} md={8} lg={9} className={classes.main}>
        {withErrorBoundary(main)}
      </Grid>

      <Grid item xs={12} md={4} lg={3}>
        {withErrorBoundary(rightBar)}
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles((theme: ThemeType) => ({
  root: {
    padding: theme.spacing(2),
    marginTop: -16
  },

  main: {
    flex: 1,

    [theme.breakpoints.down("sm")]: {
      order: 10
    },

    "& > div:not(:last-child)": {
      marginBottom: theme.spacing(2)
    }
  }
}));

export default AccommodationProfileLayout;
